"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SidePane = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactUse = require("react-use");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _ScreenshareDisplay = require("../components/ScreenshareDisplay");
var _ScreenshareTile = _interopRequireDefault(require("../components/ScreenshareTile"));
var _VideoList = _interopRequireDefault(require("../components/VideoList"));
var _VideoTile = _interopRequireDefault(require("../components/VideoTile"));
var _VideoPlayer = require("../components/Playlist/VideoPlayer");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ScreenShareView = function ScreenShareView() {
  var _peerPresenting$roleN;
  // for smaller screen we will show sidebar in bottom
  var mediaQueryLg = _reactUi.config.media.lg;
  var showSidebarInBottom = (0, _reactUse.useMedia)(mediaQueryLg);
  var peers = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeers);
  var localPeerID = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerID);
  var localPeerRole = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeerRoleName);
  var peerPresenting = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerScreenSharing);
  var peerSharingPlaylist = (0, _reactSdk.useHMSStore)(_reactSdk.selectPeerSharingVideoPlaylist);
  var isPresenterFromMyRole = (peerPresenting === null || peerPresenting === void 0 ? void 0 : (_peerPresenting$roleN = peerPresenting.roleName) === null || _peerPresenting$roleN === void 0 ? void 0 : _peerPresenting$roleN.toLowerCase()) === (localPeerRole === null || localPeerRole === void 0 ? void 0 : localPeerRole.toLowerCase());
  var amIPresenting = localPeerID === (peerPresenting === null || peerPresenting === void 0 ? void 0 : peerPresenting.id);
  var showPresenterInSmallTile = showSidebarInBottom || amIPresenting || isPresenterFromMyRole;
  var smallTilePeers = (0, _react.useMemo)(function () {
    var smallTilePeers = peers.filter(function (peer) {
      return peer.id !== (peerPresenting === null || peerPresenting === void 0 ? void 0 : peerPresenting.id);
    });
    if (showPresenterInSmallTile && peerPresenting) {
      smallTilePeers.unshift(peerPresenting); // put presenter on first page
    }

    return smallTilePeers;
  }, [peers, peerPresenting, showPresenterInSmallTile]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      size: "100%"
    },
    direction: showSidebarInBottom ? "column" : "row",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ScreenShareComponent, {
      amIPresenting: amIPresenting,
      peerPresenting: peerPresenting,
      peerSharingPlaylist: peerSharingPlaylist
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      direction: {
        "@initial": "column",
        "@lg": "row"
      },
      css: {
        overflow: "hidden",
        p: "$4 $8",
        flex: "0 0 20%",
        "@lg": {
          flex: "1 1 0"
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SidePane, {
        showSidebarInBottom: showSidebarInBottom,
        peerScreenSharing: peerPresenting,
        isPresenterInSmallTiles: showPresenterInSmallTile,
        smallTilePeers: smallTilePeers,
        totalPeers: peers.length
      })
    })]
  });
};

// Sidepane will show the camera stream of the main peer who is screensharing
// and both camera + screen(if applicable) of others
var SidePane = function SidePane(_ref) {
  var isPresenterInSmallTiles = _ref.isPresenterInSmallTiles,
    peerScreenSharing = _ref.peerScreenSharing,
    smallTilePeers = _ref.smallTilePeers,
    totalPeers = _ref.totalPeers,
    showSidebarInBottom = _ref.showSidebarInBottom;
  // The main peer's screenshare is already being shown in center view
  var shouldShowScreenFn = (0, _react.useCallback)(function (peer) {
    return peerScreenSharing && peer.id !== peerScreenSharing.id;
  }, [peerScreenSharing]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [!isPresenterInSmallTiles && /*#__PURE__*/(0, _jsxRuntime.jsx)(LargeTilePeerView, {
      peerScreenSharing: peerScreenSharing
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SmallTilePeersView, {
      showSidebarInBottom: showSidebarInBottom,
      smallTilePeers: smallTilePeers,
      shouldShowScreenFn: shouldShowScreenFn
    })]
  });
};
exports.SidePane = SidePane;
var ScreenShareComponent = function ScreenShareComponent(_ref2) {
  var showStats = _ref2.showStats,
    amIPresenting = _ref2.amIPresenting,
    peerPresenting = _ref2.peerPresenting,
    peerSharingPlaylist = _ref2.peerSharingPlaylist;
  var screenshareTrack = (0, _reactSdk.useHMSStore)((0, _reactSdk.selectScreenShareByPeerID)(peerPresenting === null || peerPresenting === void 0 ? void 0 : peerPresenting.id));
  if (peerSharingPlaylist) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        mx: "$8",
        flex: "3 1 0",
        "@lg": {
          flex: "2 1 0",
          display: "flex",
          alignItems: "center"
        }
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoPlayer.VideoPlayer, {
        peerId: peerSharingPlaylist.id
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      flex: "3 1 0",
      mx: "$8",
      "@lg": {
        ml: "$4",
        maxHeight: "80%"
      }
    },
    children: peerPresenting && (amIPresenting && !["browser", "window", "application"].includes(screenshareTrack === null || screenshareTrack === void 0 ? void 0 : screenshareTrack.displaySurface) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        objectFit: "contain",
        h: "100%"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenshareDisplay.ScreenshareDisplay, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenshareTile["default"], {
      peerId: peerPresenting === null || peerPresenting === void 0 ? void 0 : peerPresenting.id
    }))
  });
};
var SmallTilePeersView = function SmallTilePeersView(_ref3) {
  var smallTilePeers = _ref3.smallTilePeers,
    shouldShowScreenFn = _ref3.shouldShowScreenFn,
    showStatsOnTiles = _ref3.showStatsOnTiles,
    showSidebarInBottom = _ref3.showSidebarInBottom;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    css: {
      flex: "2 1 0"
    },
    children: smallTilePeers && smallTilePeers.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoList["default"], {
      peers: smallTilePeers,
      maxColCount: showSidebarInBottom ? undefined : 2,
      maxRowCount: showSidebarInBottom ? 1 : undefined,
      includeScreenShareForPeer: shouldShowScreenFn,
      showStatsOnTiles: showStatsOnTiles
    })
  });
};
var LargeTilePeerView = function LargeTilePeerView(_ref4) {
  var peerScreenSharing = _ref4.peerScreenSharing,
    showStatsOnTiles = _ref4.showStatsOnTiles;
  return peerScreenSharing ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
    css: {
      flex: "1 1 0",
      minHeight: "25%",
      py: "$4",
      "@lg": {
        mr: "$4",
        minHeight: "unset",
        py: 0
      },
      "@sm": {
        height: "100%",
        maxHeight: "75%",
        alignSelf: "center"
      }
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoTile["default"], {
      showStatsOnTiles: showStatsOnTiles,
      width: "100%",
      height: "100%",
      peerId: peerScreenSharing.id
    })
  }) : null;
};
var _default = ScreenShareView;
exports["default"] = _default;